import React, { Fragment } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import { SITENAMEALIAS } from '../utils/init';
import { Link,withRouter } from 'react-router-dom';
import btcLogo from '../assets/images/currency/BTC.svg'


class Balances extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            pageNo: 1,
            noOfItemsPerPage: 20,
        };

    }


    render() {
        return (
            <Fragment>
                <div className="container-scroller">
                    <Sidebar />
                    <Header />
                    <div className="main-panel">
                        <div className="row">
                            <div className="col-lg-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-lg-10 mt-3">
                                                <h3>Available Balance : <span>$0.00</span></h3>
                                            </div>
                                            <div className="col-lg-2">
                                            <button type="button" className="btn btn-lg btn-inverse-primary btn-fw"> Withdraw</button>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th colSpan="3" width="500px">Name</th>
                                                        <th>Balance</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="3" width="500px">
                                                            <img src={btcLogo} className="asset-icons"/>
                                                            <b>Bitcoin</b>
                                                        </td>
                                                        <td>
                                                            <b>0.000 BTC</b>
                                                            <small className='ml-2'>$ 0.00</small>
                                                        </td>
                                                        <td>
                                                            {/* <label className="badge badge-danger">Pending</label> */}
                                                            <button type="button" className="btn btn-primary"> Withdraw</button>
                                                        </td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                    <Loader show={this.state.showLoader} />
                </div>
            </Fragment>

        )
    }

    componentDidMount() {


    }

}



export default withRouter(Balances);

